const values = [
  {
    icon: "ri-heart-3-line",
    title: "真心推荐",
    desc: "每一部作品都由编辑部亲手读过才收录，不夹带私货，只推真正打动人心的治愈佳作。",
  },
  {
    icon: "ri-eye-line",
    title: "懂你口味",
    desc: "用软萌画风、温馨剧情、可爱角色等标签帮你精准筛选，快速定位合口味的作品。",
  },
  {
    icon: "ri-calendar-check-line",
    title: "持续更新",
    desc: "日常更新治愈向清单与追更动态，让你不错过任何一部人气新作与更新话数。",
  },
];

const testimonials = [
  {
    name: "小橘子",
    role: "软萌画风爱好者",
    text: "在这里按软萌画风标签找作品太方便了，推荐的每一部画风都软到我心里。",
    color: "bg-accent-100 text-accent-700",
  },
  {
    name: "奶盖",
    role: "治愈系漫画清单常客",
    text: "心情低落时就会翻翻治愈清单，温馨剧情真的能让人慢慢好起来。",
    color: "bg-secondary-100 text-secondary-900",
  },
  {
    name: "布丁",
    role: "可爱角色收集控",
    text: "可爱角色合集是我的快乐源泉，追更提醒很贴心，一次都没漏更过。",
    color: "bg-primary-100 text-primary-700",
  },
];

export default function About() {
  return (
    <section id="about" className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-bold uppercase tracking-widest text-primary-600">
            关于我们
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
            皮皮喵漫画的初心
          </h2>
          <p className="mt-3 text-foreground-700">
            皮皮喵漫画是一群热爱治愈系漫画的人聚在一起做的小站，
            我们相信软萌的画风和温馨的剧情，能成为日常里最温柔的安慰。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {values.map((value) => (
            <div
              key={value.title}
              className="rounded-2xl bg-background-100 p-6 ring-1 ring-background-200"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className={`${value.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-xl text-foreground-950">
                {value.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {value.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-2xl bg-background-100 p-6 ring-1 ring-background-200 md:p-10">
          <h3 className="text-center font-heading text-2xl text-foreground-950">
            读者怎么说
          </h3>
          <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col rounded-xl bg-background-50 p-5 ring-1 ring-background-200"
              >
                <div className="flex gap-0.5 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-full font-heading ${t.color}`}
                  >
                    {t.name[0]}
                  </span>
                  <div>
                    <div className="text-sm font-bold text-foreground-950">
                      {t.name}
                    </div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}